<template>
    <div class="box">
        <TheHeader class="hd"/>
        <div class="maintainer">
            <TheNav class="nav"/>
            <div class="container">
                <TheTab class="tabs"/>
                <keep-alive>
                    <router-view class="main"></router-view>
                </keep-alive>
            </div>
        </div>
    </div>
</template>
<script>
import TheNav from '@/view/components/TheNav.vue'
import TheTab from '@/view/components/TheTab.vue'
import TheHeader from '@/view/components/TheHeader'
export default {
  name: 'maintainer',
  components: { TheNav, TheTab, TheHeader }
}
</script>
<style lang="scss" scoped>
.box{
    overflow: hidden;
}
.maintainer {
    margin-top: 56px;
    display: flex;
    font-size: 0;
}
.hd{
    height: 56px;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    line-height: 56px;
}
.nav,
.container {
  height: calc(100vh - 56px);
  font-size: 1rem;
  display: inline-block;
}

.nav {
  position: relative;
  width: 180px;
}
.container {
  width: calc(100% - 180px);

  .tabs,
  .main {
    width: 100%;
  }

  .tabs {
    padding: 0 10px;
    padding-right: 120px;
    height: 40px;
    box-shadow: 0px 3px 10px rgba(38, 153, 251, 0.1);
    overflow-x: auto;
  }
  .main {
    padding: 10px;
    height: calc(100% - 40px);
    background-color: $bg-color;
    overflow: auto;
  }
}
</style>
